import z from 'zod';

export type ValidatorAccountFormSchemaValues = z.infer<typeof validatorAccountFormSchema>;
export const validatorAccountFormSchema = z.object({
    name: z.string().nonempty(),
    description: z.string().optional(),
    users: z.array(z.string()).optional(),
    cloud_users: z.array(z.string()).optional(),
});
